import type { ButtonProps, ButtonSize } from "@design-system/Button/Button";

/**
 * The variant × size availability matrix from
 * `docs/specs/2026-08-20-button-figma-extraction.md` §2, mirrored here so the
 * playground only ever offers combinations the component's type union allows.
 */
export const allSizes = ["xs", "sm", "md", "lg", "xl"] as const;
export const sizesFrom24 = ["sm", "md", "lg", "xl"] as const;
export const ghostSizes = ["md"] as const;
export const linkSizes = ["xs", "sm"] as const;

export const buttonVariants = [
    "primary",
    "secondary",
    "tertiary",
    "destructive",
    "ghost",
    "accent",
    "link",
] as const satisfies ReadonlyArray<ButtonProps["variant"]>;

export type ButtonVariant = (typeof buttonVariants)[number];

export const sizeOptionsByVariant = {
    primary: allSizes,
    secondary: allSizes,
    tertiary: sizesFrom24,
    destructive: sizesFrom24,
    ghost: ghostSizes,
    accent: ghostSizes,
    link: linkSizes,
} as const satisfies Record<ButtonVariant, readonly ButtonSize[]>;

/** Matches the component's own fallback: md everywhere. Link is the exception: sm, since md is illegal for that variant. */
export const defaultSizeByVariant = {
    primary: "md",
    secondary: "md",
    tertiary: "md",
    destructive: "md",
    ghost: "md",
    accent: "md",
    link: "sm",
} as const satisfies Record<ButtonVariant, ButtonSize>;

export const ghostLabelStyles = ["s-regular", "xs-medium"] as const;

export type GhostLabelStyle = (typeof ghostLabelStyles)[number];
